import store from '@state/store'
import { lazyLoadView } from '@router/helpers'

export default [
  {
    path: '/status_update/:statusUpdateId',
    name: 'status_update',
    component: () =>
      lazyLoadView(
        import(/* webpackChunkName: "interest" */ './views/statusUpdate.vue')
      ),
    meta: {
      authRequired: true,
      tmp: {},
      beforeResolve(routeTo, routeFrom, next) {
        routeTo.meta.tmp.statusUpdateId = parseInt(
          routeTo.params.statusUpdateId
        )
        handleRoute()
        function handleRoute() {
          return Promise.all([
            store.dispatch('posts/fetchStatusUpdate', {
              statusUpdateId: routeTo.params.statusUpdateId,
            }),
          ])
            .then(() => {
              next()
            })
            .catch(() => {
              // redirect to the 404 page.
              next({ name: '404', params: { resource: 'Status update' } })
            })
        }
      },
    },
    props: (route) => ({
      statusUpdate: route.meta.tmp.statusUpdate,
      statusUpdateId: parseInt(route.meta.tmp.statusUpdateId, 10),
    }),
  },
]
